<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
//import { WECHAT_BROWSER } from "./utils/browser.js"
export default {
  name: 'App',
  data() {
    return {
      value1: '',
      value2: 'a',
      show: false,
      searchvalue:''
    }
  },
  
  watch: {
    // $route: {
    //   immediate: true,
    //   deep: true,
    //   handler(to, from) {
    //     if (!WECHAT_BROWSER) return;
    //     // 不会刷新浏览器，只是让微信浏览器同步当前url
    //     // eslint-disable-next-line
    //     window.location.href = window.location.href
    //   }
    // },
    $route: {
      immediate: true,
      deep: true,
      handler(to) {
      // 微信浏览器判断
      const WECHAT_BROWSER = navigator.userAgent.toLowerCase().includes('micromessenger')
    
      // 解决iOS微信浏览器分享地址只能是落地页的问题，这个操作是不会刷新页面的，query参数改变也会执行
      if (WECHAT_BROWSER) {
        // eslint-disable-next-line
        window.location.href = window.location.href
      }
     }
    }
  },
  created(){
    
  }
  
}

</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.top{
  background: #fff;
  position: relative;
  height: 60px;
}
.top img{
    width: 70%;
    margin-top: 10px;
    margin-left: 20px
}
.top button{
  position: absolute;
  right: 20px;
  top: 10px
}
.van-cell__value--alone{
 text-align: center
}
.top2{
  width: 100%;
  overflow: hidden;
}
.top2>div:nth-child(1){
  float: left;
  width: 98%;
}
.top2>div:nth-child(2) button {
    margin-left: 30px;
    margin-top: 10px;
}
.van-button{
  height: 36px;
  line-height: 36px;
}
.van-cell{
  padding: 10px 14px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue